import React from 'react'
import clsx from 'clsx'
import { CircularProgress, useTheme } from '@mui/material'
import { Send } from 'iconsax-react'
import Button from '../Button2'

import useStyles from './styles'

const SendIcon = () => {
  const theme = useTheme()

  return <Send variant='Bold' size={theme.size.base} />
}

const LoadingButton = ({
  onClick,
  disabled,
  className,
  iconClass,
  loading,
  Icon: BaseIcon = SendIcon,
  children,
  smallMedia,
  ...props
}) => {
  const Icon = React.useMemo(
    () => (loading ? CircularProgress : BaseIcon),
    [loading, BaseIcon]
  )

  const classes = useStyles()

  return (
    <Button
      onClick={onClick}
      disabled={disabled || loading}
      className={clsx(classes.root, className)}
      {...props}
    >
      {!smallMedia && (
        <Icon
          className={clsx(classes.icon, iconClass, loading && classes.spinner)}
        />
      )}
      {children || 'SAVE'}
    </Button>
  )
}

export default LoadingButton
